<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div>Match History</div>
          </template>
          <template #actions>
              <ul>
                <li class="p-narrow no-border">
                  <div class="list-content">
                    <a
                      :class="{ disabled: !loaded }"
                      @click="$root.$emit('refreshMatchHistory')">
                      <font-awesome-icon
                        title="Click to refresh data."
                        :icon="['fas', 'sync-alt']"
                        size="lg"/>
                    </a>
                  </div>
                </li>
              </ul>
          </template>
        </es-header>
      </div>
      <div class="tabs-container">
        <div class="tabs">
          <ul>
            <router-link
              :to="{ path: 'batches' }"
              tag="li"
              replace
            >
              <a>BATCHES</a>
            </router-link>
            <router-link
              :to="{ path: 'transactions' }"
              tag="li"
              replace
            >
              <a>TRANSACTIONS</a>
            </router-link>
          </ul>
        </div>
      </div>
      <router-view @isPageLoaded="loaded = $event"/>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSyncAlt,
} from '@fortawesome/pro-solid-svg-icons';

import EsHeader from '@/components/EsHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

library.add(
  faSyncAlt,
);

export default {
  mixins: [
    BreadcrumbsManager,
  ],
  components: {
    EsHeader,
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'directMatch'} },
      { text: 'Match History', to: { } },
    ]);
  },
  data() {
    return {
      loaded: false,
    };
  },
};
</script>

<style lang="sass" scoped>
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
</style>
